var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group"},[(_vm.list.length > 0)?_c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,staticClass:"user-row"},[_c('groupview',{key:_vm._uid + index + 'list',attrs:{"group":item,"detailed":_vm.detailed,"has-controls":true}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }